export default {
  goodFlows(state) {
    return state.goodFlows
  },
  flowFilters(state) {
    return state.flowFilters
  },
  goodFlow(state) {
    return state.goodFlow
  },
  flowItemsCount(state) {
    return state.flowItemsCount
  },
  flowTypes(state) {
    return state.flowTypes
  },
  count(state) {
    return state.count
  },
  flowType(state) {
    return state.flowType
  },
  flowStatuses(state) {
    return state.flowStatuses
  },
  flowItems(state) {
    return state.flowItems
  },
  qtyUnits(state) {
    return state.qtyUnits
  },
}
